function formatDateToYYYYMMDD(inputDate) {
    const dateObj = new Date(inputDate);

    // Get the year, month, and day from the Date object
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(dateObj.getDate()).padStart(2, '0');

    // Format the date as yyyy/mm/dd
    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
}

function formatDateTime(inputDate) {
    const dateObj = new Date(inputDate);

    // Get the day, month, and year
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = dateObj.getFullYear();

    // Get the hours and minutes
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');

    // Get AM/PM designation
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    const formattedHours = (hours % 12) || 12;

    // Format the date as dd/mm/yyyy, hh:mm AM/PM
    const formattedDate = `${day}/${month}/${year}, ${formattedHours}:${minutes} ${ampm}`;
    return formattedDate;
}

function formatDate(inputDate) {
    const date = new Date(inputDate);
    const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    };
    return new Intl.DateTimeFormat('en', options).format(date);
}

function formatDateToDDMMYYYYHHMMSS(inputDate) {
    const date = inputDate ? new Date(inputDate) : new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

const customMonthFormat = [
    'ខែមករា', 'ខែកុម្ភៈ', 'ខែមីនា', 'ខែមេសា', 'ឧសភា', 'ខែមិថុនា',
    'ខែកក្កដា', 'ខែសីហា', 'ខែកញ្ញា', 'ខែតុលា', 'ខែវិច្ឆិកា', 'ខែធ្នូ'
];

const monthAbbreviations = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


function formatDateToEN_US(inputDate, iskhm = false) {
    const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
    };
    const date = inputDate ? new Date(inputDate) : new Date();
    const locale = "en-US"; // Use Khmer locale if iskhm is true
    const formattedDate = new Intl.DateTimeFormat(locale, options).format(date);
    let str = formattedDate;
    if (countCharInString(str, ",") > 1) {
        const lastCommaIndex = str.lastIndexOf(',');

        if (lastCommaIndex !== -1) {
            str = str.slice(0, lastCommaIndex) + str.slice(lastCommaIndex + 1);
        }
    }

    str = str.replace(/at/g, '');

    if (iskhm) {
        const firstMonth = cutFirstThreeCharacters(str);

        const indexMonth = monthAbbreviations.findIndex(x => x == firstMonth);

        let replacedString = replaceFirstThreeCharacters(str, customMonthFormat[indexMonth]);
        return replacedString;
    }
    return str;
}

function countCharInString(str, char) {
    let count = 0;
    for (let i = 0; i < str.length; i++) {
        if (str.charAt(i) === char) {
            count++;
        }
    }
    return count;
}

function replaceFirstThreeCharacters(inputString, replacement) {
    if (inputString.length >= 3) {
        // Cắt 3 ký tự đầu và thay thế bằng từ khác
        let modifiedString = replacement + inputString.slice(3);
        return modifiedString;
    } else {
        // Nếu chuỗi ngắn hơn 3 ký tự, không làm gì cả hoặc xử lý theo ý muốn
        return inputString;
    }
}


function cutFirstThreeCharacters(inputString) {
    if (inputString.length >= 3) {
        // Cắt 3 ký tự đầu
        let cutString = inputString.substring(0, 3);
        return cutString;
    } else {
        // Nếu chuỗi ngắn hơn 3 ký tự, không làm gì cả hoặc xử lý theo ý muốn
        return inputString;
    }
}

function formatDateToDDMMYYYY(date = new Date()) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

// Hiển thị: "dd/mm/yyyy" → ["yyyy", "mm", "dd"] (cho van-date-picker)
function splitDDMMYYYYtoPickerArray(dateStr) {
    const [dd, mm, yyyy] = dateStr.split('/');
    return [dd, mm, yyyy];
}

function formatArrayToDDMMYYYY(dateArray = []) {
    if (!Array.isArray(dateArray) || dateArray.length !== 3) return '';
    const [day, month, year] = dateArray;
    return `${day}/${month}/${year}`;
}

function formatDateToHHMMDDMMYYYY(inputDate) {
    const date = inputDate ? new Date(inputDate) : new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes} | ${day}/${month}/${year}`;
}

function formatDateToHHMMSpaceDDMMYYYY(inputDate) {
    const date = inputDate ? new Date(inputDate) : new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}  ${day}/${month}/${year}`;
}

// function formatToDateDDMMYYYY(inputDate) {
//     console.log("inputDate", inputDate);
//     const date = inputDate ? new Date(inputDate) : new Date();
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();
//     const hours = String(date.getHours()).padStart(2, '0');
//     const minutes = String(date.getMinutes()).padStart(2, '0');
//     const seconds = String(date.getSeconds()).padStart(2, '0');

//     return `${day}/${month}/${year} `;
// } 

function formatToDateDDMMYYYY(inputDate) {
    let date;
    if (typeof inputDate === 'string' && inputDate.includes('.')) {
        const [day, month, year] = inputDate.split('.');
        date = new Date(`${year}-${month}-${day}`);
    } else {
        date = inputDate ? new Date(inputDate) : new Date();
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}

// function formatToDateDDMMYYYY(inputDate) {
//     let day, month, year;

//     if (Array.isArray(inputDate)) {
//         [day, month, year] = inputDate;
//     } else if (typeof inputDate === 'string') {
//         // Loại bỏ tất cả ký tự không phải số
//         const digitsOnly = inputDate.replace(/\D/g, '');

//         if (digitsOnly.length === 8) {
//             // Dạng 28091999
//             day = digitsOnly.slice(0, 2);
//             month = digitsOnly.slice(2, 4);
//             year = digitsOnly.slice(4);
//         } else {
//             // Dạng có dấu phân cách: "/", ".", ",", " "
//             const parts = inputDate.split(/[\s\/\.,]+/);
//             if (parts.length === 3) {
//                 [day, month, year] = parts;
//             } else {
//                 return 'Invalid Date';
//             }
//         }
//     } else {
//         return 'Invalid Date';
//     }

//     // Đảm bảo chuẩn hóa chuỗi số
//     day = String(day).padStart(2, '0');
//     month = String(month).padStart(2, '0');
//     year = String(year);

//     return `${day}/${month}/${year}`;
// }


module.exports = {
    formatDateToYYYYMMDD,
    formatDateTime,
    formatDate,
    formatDateToDDMMYYYYHHMMSS,
    formatDateToEN_US,
    formatDateToDDMMYYYY,
    splitDDMMYYYYtoPickerArray,
    formatArrayToDDMMYYYY,
    formatDateToHHMMDDMMYYYY,
    formatToDateDDMMYYYY,
    formatDateToHHMMSpaceDDMMYYYY,
}

